import DrawerMenuItems from "./DrawerMenuItems";
import List from "@mui/material/List";

const DrawerMenu = ({ navigation, toggleDrawer }) => {
  return (
    <List component="nav" disablePadding className={"mainNav"}>
      {navigation.map((item, index) => (
        <DrawerMenuItems {...item} key={index} toggleDrawer={toggleDrawer} />
      ))}
    </List>
  );
};

export default DrawerMenu;
